module.exports = __webpack_public_path__ + "img/icon_3_6.7368ee70.png";